import Vue from 'vue';
import App from './App';
import router from './router';
import VueIntro from 'vue-introjs';
import Vue2TouchEvents from 'vue2-touch-events';
import VueAnalytics from 'vue-analytics';
import '@babel/polyfill';
import { library as FaLibrary } from '@fortawesome/fontawesome-svg-core';
import {
  faPause,
  faPlay,
  faBackward,
  faForward,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

FaLibrary.add(faPause);
FaLibrary.add(faPlay);
FaLibrary.add(faBackward);
FaLibrary.add(faForward);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueIntro);
Vue.use(Vue2TouchEvents);
Vue.use(VueAnalytics, {
  id: 'UA-170205123-2',
  router,
});

Vue.config.productionTip = false;

import 'intro.js/introjs.css';

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js